import { padStart } from 'lodash';

export const padLeft = (value: string, length: number) =>
    value && value !== '0' ? padStart(value, length, '0') : value || '';

export const normalizePaddedNumbersRange = (rangeStart: number, rangeEnd: number) => {
    const rule = rangeStart < 0 ? /^-?(?:\d+|\d*)$/ : /^[0]?[0-9]+$/;
    return (value: string, previousValue: string) => {
        if (!value) return '';
        if (!rule.test(value)) return previousValue;
        const valueInt = parseInt(value);
        if (isNaN(valueInt)) return value;
        if (valueInt < rangeStart || valueInt > rangeEnd) return previousValue;
        return value;
    };
};

export const normalizeNumbersAndSlashes = (value: string, previousValue: string) => {
    const rule = /^[0-9/]*$/;
    if (!value) return '';
    if (!rule.test(value)) return previousValue;
    return value;
};
